import React from 'react';
import { withRouter } from 'react-router-dom';

import { withFormik } from 'formik';
import * as yup from 'yup';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import Input from '../../components/Input/Input';
import { phoneMask, cepMask } from '../../shared/masks';

const styles = theme => ({
  button: {
    display: 'inherit',
    margin: `${theme.spacing(2)}px auto`,
    minWidth: '300px',
    minHeight: '50px',
  },
});

const Form = ({
  classes,
  loading,
  data,
  title,
  values,
  offices,
  departments,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  setFieldValue,
}) => {
  const formFields = [
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'name',
        label: 'Nome',
        required: true,
      },
      helperText: ' ',
    },
    {
      elementType: 'maskedInput',
      config: {
        type: 'text',
        name: 'phone',
        label: 'Telefone',
        required: true,
        mask: phoneMask,
      },
      helperText: ' ',
    },
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'enrollment',
        label: 'Matrícula',
      },
      helperText: ' ',
    },
    {
      elementType: 'select',
      config: {
        name: 'departmentId',
        label: 'Departamento',
        required: true,
        options: departments.map(department => ({
          value: department.id,
          displayValue: department.name,
        })),
      },
      helperText: ' ',
    },
    {
      elementType: 'select',
      config: {
        name: 'officeId',
        label: 'Cargo',
        required: true,
        options: offices.map(office => ({
          value: office.id,
          displayValue: office.name,
        })),
      },
      helperText: ' ',
    },
    {
      elementType: 'maskedInput',
      config: {
        type: 'text',
        name: 'cpf',
        label: 'CPF',
        // mask: [],
        mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
        required: true,
      },
      helperText: ' ',
    },
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'pisCode',
        label: 'PIS',
        required: false,
      },
      helperText: ' ',
    },
    {
      elementType: 'maskedInput',
      config: {
        type: 'text',
        name: 'postalCode',
        label: 'Cep',
        mask: cepMask,
        required: true,
      },
      helperText: ' ',
    },
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'address',
        label: 'Endereço',
        required: true,
      },
      helperText: ' ',
    },
    {
      elementType: 'datePicker',
      config: {
        name: 'admission',
        label: 'Data de Admissão',
        required: true,
        isFormik: true,
      },
      helperText: ' ',
    },
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'emailContact',
        label: 'Email',
      },
      helperText: ' ',
    },
  ];

  const addLeadingZero = (e, field) => {
    if (field.config.name === 'pisCode' && e.target.value.length) {
      // if (e.target.value.length === 11 && e.target.value.length > this.previousLength) {
      //   e.target.value = "0" +  e.target.value;
      // }

      if (e.target.value.length > 12) {
        e.target.value = e.target.value.slice(0, 12);
      }

      e.target.value = e.target.value.replace(/\D+/g, '');
      this.previousLength = e.target.value.length;
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid item container spacing={2}>
        {formFields.map(field => (
          <Grid item xs={12} sm={6} key={field.config.name}>
            <Input
              {...field.config}
              elementType={field.elementType}
              onInput= {e => addLeadingZero(e, field)}
              value={values[field.config.name]}
              onChange={field.elementType === 'datePicker' ? setFieldValue : handleChange}
              onBlur={handleBlur}
              fullWidth
              margin="normal"
              // error={errors[field.config.name] && touched[field.config.name]}
              error={errors[field.config.name] && touched[field.config.name]}
              helperText={
                (touched[field.config.name] && errors[field.config.name]) || field.helperText
              }
            />
          </Grid>
        ))}
      </Grid>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.button}
        disabled={loading}
      >
        {title === 'Cadastrar' ? (
          loading ? (
            <CircularProgress size={20} color="primary" />
          ) : (
            'CADASTRAR'
          )
        ) : loading ? (
          <CircularProgress size={20} color="primary" />
        ) : (
          'ATUALIZAR'
        )}
      </Button>
    </form>
  );
};

const initializeItemForm = item => item || '';

const initializeDateItemForm = item => (item ? item.split('T')[0] : new Date());

const UpdateEmployeeForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    const data = props.dataToKeep || {};
    return ({
      name: data.name || initializeItemForm(props.data.name),
      phone: data.phone || initializeItemForm(props.data.phone),
      enrollment: data.enrollment || initializeItemForm(props.data.enrollment),
      departmentId: data.departmentId || initializeItemForm(props.data.departmentId),
      officeId: data.officeId || initializeItemForm(props.data.officeId),
      cpf: data.cpf || initializeItemForm(props.data.cpf),
      postalCode: data.postalCode || initializeItemForm(props.data.postalCode),
      pisCode: data.pisCode || initializeItemForm(props.data.pisCode),
      address: data.address || initializeItemForm(props.data.address),
      admission: data.admission || initializeDateItemForm(props.data.admission),
      emailContact: data.emailContact || initializeItemForm(props.data.emailContact),

    });
  },
  validationSchema: yup.object().shape({
    name: yup.string().required(),
    phone: yup.string().strict(false).trim('Informe um formato válido').required(),
    enrollment: yup.string(),
    departmentId: yup
      .number()
      .integer()
      .required(),
    officeId: yup
      .number()
      .integer()
      .required(),
    cpf: yup.string().strict(false).trim('O CPF deve conter 11 dígitos').required(),
    postalCode: yup.string().required(),
    pisCode: yup.string().min(10, 'O PIS deve conter 10 dígitos no mínimo'),
    address: yup.string().required(),
    admission: yup.string().required(),
    emailContact: yup.string().email(),
  }),
  handleSubmit: (values, { props }) => {
    const data = {
      ...values,
      enrollment: values.enrollment.trim() || null,
      phone: values.phone.replace(/\D+/g, ''),
      postalCode: values.postalCode.toString().replace(/\D+/g, ''),
      cpf: values.cpf.replace(/\D+/g, ''),
      pisCode: values.pisCode.length ? (values.pisCode.length === 10 ? `00${  values.pisCode}` : (values.pisCode.length === 11 ? `0${  values.pisCode}` : values.pisCode)) : null,
    };
    if (props.data.id) {
      data.id = props.data.id;
    }
    props
      .onUpdateEmployee(data)
      .then(() => props.history.push('/funcionarios'))
      .catch((error) => {
        props.keepData(values);
        return error;
      });
  },
})(Form);

export default withStyles(styles)(withRouter(UpdateEmployeeForm));
